// extracted by mini-css-extract-plugin
export var flowchartContainer = "_j-0";